module.exports = "/assets/7b1cb67d148a5abb0ddfb6ced88b3726.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/R3.png
// module id = 1773
// module chunks = 0